import axios from "axios";

const RAW_BASE = import.meta.env.VITE_API_BASE || "http://localhost:5000";
const NORMALIZED_BASE = RAW_BASE.replace(/\/+$/, "");
const BASE_WITHOUT_API = NORMALIZED_BASE.endsWith("/api")
  ? NORMALIZED_BASE.slice(0, -4)
  : NORMALIZED_BASE;
axios.defaults.baseURL = BASE_WITHOUT_API;
axios.defaults.withCredentials = true;

let csrfToken = null;

export function setCsrfToken(token) {
  csrfToken = token || null;
}

axios.interceptors.request.use((config) => {
  const method = String(config.method || "get").toUpperCase();
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && config.withCsrf !== false && csrfToken) {
    config.headers = { ...config.headers, "X-CSRF-Token": csrfToken };
  }
  return config;
});

export async function fetchSiteConfigs() {
  const res = await axios.get("/api/site-configs");
  return res.data;
}

export async function fetchFuelTypes() {
  const res = await axios.get("/api/fuel-types");
  return res.data;
}

export async function fetchAbcBatchTargets() {
  const res = await axios.get("/api/admin/abc-batch-targets");
  return res.data;
}

export async function addAbcBatchTarget(payload) {
  const res = await axios.post("/api/admin/abc-batch-targets", payload);
  return res.data;
}

export async function updateAbcBatchTarget(id, payload) {
  const res = await axios.put(`/api/admin/abc-batch-targets/${id}`, payload);
  return res.data;
}

export async function deleteAbcBatchTarget(id) {
  const res = await axios.delete(`/api/admin/abc-batch-targets/${id}`);
  return res.data;
}

export async function getAbcBatchStatus() {
  const res = await axios.get("/api/abc/batch/status");
  return res.data;
}

export async function runAbcBatch(force = false) {
  const res = await axios.post("/api/abc/batch/run", { force });
  return res.data;
}

export async function fetchFuelCategorySettings() {
  const res = await axios.get("/api/admin/fuel-categories");
  return res.data;
}

export async function updateFuelCategorySettings(activeCategories) {
  const res = await axios.put("/api/admin/fuel-categories", {
    activeCategories,
  });
  return res.data;
}

export async function fetchCorporateDaily(params = {}) {
  const search = new URLSearchParams();
  if (params.date) {
    search.set("date", params.date);
  }
  if (params.providers && params.providers.length) search.set("provider", params.providers.join(","));
  if (params.locations && params.locations.length) search.set("location", params.locations.join(","));
  const suffix = search.toString() ? `?${search.toString()}` : "";
  const res = await axios.get(`/api/corporate/daily${suffix}`, { signal: params.signal });
  return res.data;
}

export async function fetchCorporateDailyLocations(params = {}) {
  const search = new URLSearchParams();
  if (params.date) search.set("date", params.date);
  if (params.query) search.set("query", params.query);
  if (params.scope) search.set("scope", params.scope);
  const suffix = search.toString() ? `?${search.toString()}` : "";
  const res = await axios.get(`/api/corporate/daily/locations${suffix}`, { signal: params.signal });
  return res.data;
}

export async function fetchCorporateHistory(params = {}) {
  const search = new URLSearchParams();
  if (params.startDate) search.set("from", params.startDate);
  if (params.endDate) search.set("to", params.endDate);
  if (params.providers && params.providers.length) search.set("provider", params.providers.join(","));
  if (params.locations && params.locations.length) search.set("location", params.locations.join(","));
  const suffix = search.toString() ? `?${search.toString()}` : "";
  const res = await axios.get(`/api/corporate/history${suffix}`, { signal: params.signal });
  return res.data;
}

export async function fetchCorporateHistoryLocations(params = {}) {
  const search = new URLSearchParams();
  if (params.startDate) search.set("from", params.startDate);
  if (params.endDate) search.set("to", params.endDate);
  if (params.query) search.set("query", params.query);
  if (params.scope) search.set("scope", params.scope);
  if (params.all) search.set("all", "true");
  if (params.offset) search.set("offset", String(params.offset));
  if (params.limit) search.set("limit", String(params.limit));
  const suffix = search.toString() ? `?${search.toString()}` : "";
  const res = await axios.get(`/api/corporate/history/locations${suffix}`, { signal: params.signal });
  return res.data;
}

export async function fetchCorporateHistoryYears() {
  const res = await axios.get("/api/corporate/history/years");
  return res.data;
}

export default axios;

export async function fetchCalculationRules() {
  const res = await axios.get("/api/admin/calculation-rules");
  return res.data;
}

export async function updateCalculationRules(site, rules) {
  const res = await axios.put(`/api/admin/calculation-rules/${site}`, rules);
  return res.data;
}

export async function fetchApplicationVersion() {
  const res = await axios.get("/api/admin/version");
  return res.data;
}
